const Forms = (($) => {
  let _els = {};

  const init = () => {
    _els.inputGroups = $('.input-group');

    _addListeners();
  };

  const _addListeners = () => {
    $.each(_els.inputGroups, (i, val) => {
      let input = $(val).find('input.form-control');
      input.on('focus', (e) => {
        $(val).addClass('active');
      });
      input.on('blur', (e) => {
        $(val).removeClass('active');
      });
    });
  };

  module.exports = {
    init: init,
  };
})(jQuery);
